import React from 'react'
import './style.css'

export default function ButtonMinimalist({text, onClick}) {
  return (
    <button className="Button" id='minim' onClick={onClick}>{text}</button>
  )
}